@if (documenttype) {
  <div>
    <app-documenttype-editform [editedDocumenttype]="documenttype">
    </app-documenttype-editform>
  </div>
}
